<jml-lib-entity-view
  [layout]="layout"
  [entryId]="entityReference.id"
  [configName]="entityReference.dtoType"
></jml-lib-entity-view>
